import { render, staticRenderFns } from "./MgnNavbar.vue?vue&type=template&id=e1d39122&scoped=true&"
import script from "./MgnNavbar.vue?vue&type=script&lang=js&"
export * from "./MgnNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MgnNavbar.vue?vue&type=style&index=0&id=e1d39122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d39122",
  null
  
)

export default component.exports